module.exports = __webpack_public_path__ + "static/media/accountsDepartment.2cdf2bfe.svg";